import { useTranslation } from "react-i18next";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import PersonClient from "components/PersonClient";
import clientService from "api/clientService";
import ClientsContext from "contexts/ClientsContext";
import { useContext, useMemo } from "react";
import { IClient } from "dto/IClient";
import InfoBoxClient from "components/InfoBoxClient";
import AddressClient from "components/AddressClient";
import NoteIcon from "assets/icons/note.svg?react";
import HistoryIcon from "assets/icons/history.svg?react";

const UserRightSide: FC<Props> = ({ userId }) => {
  const { t } = useTranslation();
  const { data: clientData } = clientService.useGetClient(userId ?? "");

  // @ts-expect-error data shape mismatch
  const client: IClient = useMemo(() => clientData?.data ?? [], [clientData]);

  const { clients } = useContext(ClientsContext);

  const clientContext = useMemo(
    () => clients.find((c) => c.Id === client.Id) ?? [],
    [client, clients]
  );

  if (!clientContext) {
    return <></>;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.person}>
        <PersonClient client={clientContext as IClient} />
      </div>
      <div className={styles.informations}>
        <InfoBoxClient
          // createLabel="+ Nowa notatka"
          label={
            <div className={styles.label}>
              <NoteIcon /> {t("common.notes")}
            </div>
          }
          onCreateClick={() => {}}
        >
          <></>
        </InfoBoxClient>
        <InfoBoxClient
          label={
            <div className={styles.label}>
              <HistoryIcon /> {t("common.history")}
            </div>
          }
          onCreateClick={() => {}}
        >
          <AddressClient client={client} />
        </InfoBoxClient>
        {/* <InfoBoxClient
          // createLabel="+ Nowy podmiot"
          label={
            <div className={styles.label}>
              <PersonIcon /> Kontakty
            </div>
          }
          onCreateClick={handleClickNewEntity}
        >
          <PersonsClient client={client} />
        </InfoBoxClient> */}
        {/* <InfoBoxClient
          createLabel="+ Nowa teczka"
          label={
            <div className={styles.label}>
              <CaseIcon /> Teczki
            </div>
          }
          onCreateClick={handleClickNewCase}
        >
          <CasesClient />
        </InfoBoxClient> */}
      </div>
    </div>
  );
};

export default UserRightSide;
